// extracted by mini-css-extract-plugin
export default {"container":"_1fi6NLLeTJRHCj7JLJ7mSf","contactImage":"_2I9mqFYkGzF4gXuAliG2iq","contactPerson":"_1yU8jjwkXo1rtSrJ7CBh7T"};